import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SquareImage',
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    }
  }
};